import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState, useRecoilCallback } from 'recoil';
import { atom_activeStopState } from '@app/shared/state/active-stop.atom';
import { atom_openedStopState } from "@app/shared/state/opened-stop.atom";
import { atom_showModalContent } from '@app/shared/state/show-content-modal.atom';
import { StopDetails } from "@app/features/map/stop-details/StopDetails";
import { Stop } from '@app/shared/models/tour.type';
// import { atom_modalType } from '@app/shared/state/show-content-modal.atom';
import { passiveCollector, isWithinRadius } from '@app/shared/services/passive-data/passive-data-collector';
import { atom_geolocationState } from '@app/shared/state/geolocation.atom';


function isHebrew() {
    const lang = (typeof window !== 'undefined' && window.localStorage.getItem('i18nextLng')) || 'he';
    return lang === 'he';
}

const StopsCardsContent: React.FC = () => {
    const t = useTranslation()[0];
    const state_activeStopState = useRecoilValue(atom_activeStopState);
    const state_openedStopState = useRecoilValue(atom_openedStopState);
    const setState_openedStopState = useSetRecoilState(atom_openedStopState);
    const setState_showModal = useSetRecoilState(atom_showModalContent);
    // const setState_showedModalType = useSetRecoilState(atom_modalType);
    const getGeolocation = useRecoilCallback(({ snapshot }) => () => {
        return snapshot.getLoadable(atom_geolocationState).getValue();
    });
    const [stopDetailsPaddingTop, setStopDetailsPaddingTop] = useState(20);


    const handleStopCardClick = (stop: Stop) => {
        setState_openedStopState(stop);
    };

    const handleContentChange = (paddingTop: number) => {
        setStopDetailsPaddingTop(paddingTop);
    };

    return state_activeStopState?.type === 'smallStop' ? (
        <Box
            role="document"
            style={{
                paddingTop: stopDetailsPaddingTop,
                backgroundColor: 'white',
                direction: isHebrew() ? 'rtl' : 'ltr',
                textAlign: 'center',
            }}
        >
            <StopDetails onContentChange={handleContentChange} />
        </Box>
    ) : (
        <Box
            role="document"
            style={{
                maxHeight: '90vh',
                paddingTop: 20,
                minHeight: 'auto',
                padding: 20,
                borderRadius: 20,
                width: '100%',
                direction: isHebrew() ? 'rtl' : 'ltr',
                textAlign: 'center',
                backgroundColor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                // gap: 12,
                maxWidth: '100%',
                overflow: 'hidden',
            }}
        >
            {/* <Typography id="stop-modal-title" style={{ position: 'absolute', top: 14, left: 0, right: 0, textAlign: 'center' }} variant="h5" component="h2"> {t('on_tour.stop.next_stop')}</Typography> */}
            <Typography style={{ marginTop: 50 }} variant="h4">{state_activeStopState?.s_title}</Typography>
            <Typography style={{ marginTop: 16 }}>{state_activeStopState?.diraction_text}</Typography>
            {state_activeStopState?.loc_pics?.[0]?.url && (
                <Box className="flex justify-center"
                    sx={{ marginTop: 2, marginBottom: 6 }}
                >
                    <img
                        style={{ maxHeight: '35vh', borderRadius: 12 }}
                        src={
                            state_activeStopState?.loc_pics?.[0]?.url?.split('&token=')?.[0]
                        }
                        alt={(state_activeStopState?.s_title ? t('accessibility.stop_image', { title: state_activeStopState.s_title }) : t('accessibility.stop_image_generic')) as string}
                    />
                </Box>
            )}


            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '50px',
                    position: 'relative',
                    padding: '0 15px',
                    overflow: 'hidden',
                }}
            >
                <Button
                    style={{
                        textAlign: 'center',
                        width: '100%',
                    }}
                    onClick={() => {
                        // Update localStorage modalType from 'stopsCards' to 'bigStop'
                        Object.keys(localStorage).forEach(key => {
                            if (key.startsWith('stop_modal_state_')) {
                                try {
                                    const savedState = localStorage.getItem(key);
                                    if (savedState) {
                                        const parsedState = JSON.parse(savedState);
                                        parsedState.modalType = 'bigStop';
                                        localStorage.setItem(key, JSON.stringify(parsedState));
                                    }
                                } catch (error) {
                                    console.error('Error updating stop modal state:', error);
                                }
                            }
                        });

                        // Track big stop content view
                        if (state_activeStopState) {
                            const geo = getGeolocation();
                            passiveCollector.trackStopViewed(state_activeStopState as Stop, isWithinRadius(geo.latitude, geo.longitude, state_activeStopState as Stop));
                        }

                        if (state_openedStopState?.id && state_openedStopState?.id !== (state_activeStopState as Stop)?.id) {
                            setState_openedStopState(undefined);
                            setTimeout(() => {
                                handleStopCardClick(state_activeStopState as Stop);
                            }, 0);
                        } else {
                            handleStopCardClick(state_activeStopState as Stop);
                        }
                        setState_showModal(false);
                    }}
                    aria-label={t('accessibility.show_content_for_stop', { action: t('on_tour.stop.show_me_content'), stopName: state_activeStopState?.s_title }) as string}
                >
                    {t('on_tour.stop.show_me_content')}
                </Button>
            </Box>
        </Box>
    );
};

export default StopsCardsContent;
